Application.BackgroundSwitch = {
    ui: {
        container: '.js-bg-switch',
        target: '.js-bg-switch__target',
        switch: '.js-bg-switch__switch',
    },
    ready: function () {

        var self = this;

        if (!$(this.ui.container).length){
            return;
        }

        // change time units
        $(this.ui.switch).change(function(){
            self.update($(this).closest(self.ui.container), $(this).attr('data-bg-id'));
        });

        // init
        var $active = $(this.ui.switch).filter(':checked');
        this.update($active.closest(self.ui.container), $active.attr('data-bg-id'));

    },
    update: function($container, id){

        var $target = $container.find(this.ui.target);
        var options = JSON.parse($target.attr('data-bg-options'));

        // save default on first change
        if (!$target.attr('data-bg-default')){
            $target.attr('data-bg-default', $target.css('background-image'));
        }

        $target.animate({opacity: 0}, 250, function(){
            // change bgs
            if (options[id]){
                $target.css('background-image', 'url(' + options[id] + ')');
            }else{
                $target.css('background-image', $target.attr('data-bg-default'));
            }
            $target.animate({opacity: 1}, 250);
        })


    }
};